import { Injectable } from '@angular/core';
import { StorageService } from '@app/services/storage';
import { GeneralApiService, StatusApi } from '@global-service/api';
import { RegimenFiscal } from '@config-empresa/sociedades/interfaces';

@Injectable()
export class RegimenesFiscalesService {
  constructor(private readonly generalApi: GeneralApiService, private readonly storageService: StorageService) {}

  listadoRegimenesFiscales(loading?: StatusApi) { 
    return this.generalApi.callApi<RegimenFiscal[]>('get', `/empresa/${this.storageService.getEmpresaID()}/regimenesFiscales`, {
      loading,
      keyResult: null
    });
  }
}
